import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import Title from "../Co Components/Titles";
import TXD from '../assets/Images/partners/TXD.png';
import convserv from '../assets/Images/partners/convserv.png';
import itbuilder from '../assets/Images/partners/itbuilders.jpg';
import ldc from '../assets/Images/partners/ldc.png';
import cylert from '../assets/Images/partners/CYlert.jpg';
import iexperts from '../assets/Images/partners/iexperts.png';
import digitalHub from '../assets/Images/partners/Digital-Hub.png';
import ebdaa from '../assets/Images/partners/3Asset-1-1.svg';
import ict from '../assets/Images/partners/ict_libya.png';

import Rectangle from "../Co Components/RectangleCards";
import LineButton from "../Co Components/LineButton";
import cardImage from '../assets/Images/9.png';
import { useEffect } from 'react';
import PartnerCard from "../Co Components/PartnerCard";

const Resellers = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <Title className={''} header={"our"} body={"RESELLERS"} />
            <center>
                <p className={'fs-6 Poppins  w-100'}>
                            Our partnerships with trusted resellers allow us to bring you what you need to equip<br/> your organizations with the services they need across the globe.

                </p>
            </center>
            <div className={'container justify-content-center'}>
                <center>
                    <p className={'fs-6 Poppins  w-100'}>
                        Explore the Possibilities Across Our Reseller Partners
                    </p>
                </center>
                <div className={' mb-5 row justify-content-center '}>
                    <PartnerCard
                        to={'https://www.txdsystems.com/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={TXD}
                        Title={'TXD Systems Tech Xperts'}
                        address={'24 yousry fahmy, El-Sayed El-Merghany, Heliopolis, Cairo Governorate, Cairo, Egypt'}
                        email={'info@txdsystems.com'}
                        phone={'+022 2913873'}
                    />
                    <PartnerCard
                         to={'https://conservmisr.com/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={convserv}
                        Title={'ConServ Misr'}
                        address={'Administrative Building No. 5 - Zizinia Resort - Fifth Settlement - New Cairo-Egypt'}
                        email={'info@conservmisr.com'}
                        phone={'+220 227342321'}
                    />

                    <PartnerCard
                        to={'https://itbuilders.com.sa/'}
                        Title={'IT Builders'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={itbuilder}
                        address={'Wadi AlJarir ST, Sultana Building 3701, 1ST floor, office 35, Olaya Computer Market, Riyadh 12211, Saudi arabia\n' +
                            '\n' +
                            'Riyadh, SA'}

                    />
                    <PartnerCard
                        to={'https://www.linkdatacenter.net/en/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={ldc}
                        Title={'Link Data Center'}
                        email={'info@linkdatacenter.net'}
                        phone={'+2012 1280 0060'}
                        address={'Villa #7 Street 206, Maadi,\n' +
                            'Degla Square, Cairo\n' +
                            'Governorate, Egypt. 4213012'}

                    />
                    <PartnerCard
                        to={'https://www.cylert-me.com/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={cylert}
                        Title={'Cylert'}
                        email={'info@cylert-me.com'}
                        phone={'+201022034444'}
                        address={'Masaken Sheraton, Minister Square 1164, Building 3, Heliopolis, Cairo, Egypt'}

                    />
                    <PartnerCard
                        to={'https://www.iexperts.co/Index'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={iexperts}
                        Title={'IExperts'}
                        email={'info@iExperts.co'}
                        phone={'+02 38 260 709'}
                        address={'D1, GrEEK Campus West, Mall of Arabia, 6th October City, Giza, Egypt'}

                    />
                    <PartnerCard
                        to={'https://www.linkdatacenter.net/en/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={digitalHub}
                        Title={'Digital Hub'}
                        email={'sales@digitalhubgroup.com'}
                        phone={'+20 155 555 3064'}
                        address={'Villa 52 80 Axis, New Cairo 1, Cairo Governorate 4722502'}

                    />
                    <PartnerCard
                        to={'https://ictlibya.com/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={ict}
                        Title={'ICT LIBYA'}
                        email={'info@ictlibya.com'}
                        address={'Al Nofleen Area, Tripoli, Libya'}

                    />
                    <PartnerCard
                        to={'https://qcdt.ly/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={ebdaa}
                        Title={'QEMAT ALEBDAA'}
                        email={'info@qcdt.ly'}
                        phone={'+ 218 (091/2) 896-1113'}
                        address={'Nofleen, Tripoli, Libya'}

                    />

                </div>
            </div>


            <Footer />
        </>
    );

}

export default Resellers;